import React, {useEffect} from "react";
import {YMInput} from "@/component/input/YMInput";
import {DateNav} from "@/component/view/DateNav";
import {FtButton} from "@/common/FtButton";
import {FtDate} from "@/common/util/FtDate";

interface Props {
    ymFrom: string;
    ymTo: string;
    mode: 'MONTH' | 'YEAR';
    recent?: number;
    onChange: (ymdFrom: string, ymdTo: string) => void;
}

export function YmTermInput(props: Props) {
    const {ymFrom, ymTo, mode, recent, onChange} = props;
    const [ymFromInput, setYmFromInput] = React.useState(ymFrom);
    const [ymToInput, setYmToInput] = React.useState(ymTo);

    useEffect(() => {
        setYmFromInput(ymFrom);
        setYmToInput(ymTo);
    }, [ymFrom, ymTo]);

    function todayAction() {
        if (mode === 'MONTH') {
            move(new FtDate().ym(), new FtDate().ym());
        } else {
            move(new FtDate().setMonth(1).ym(), new FtDate().ym());
        }
    }

    function move(from: string, to: string) {
        onChange(from, to);
    }

    const incrementUnit = mode === 'MONTH' ? 1 : 12;
    function increase(increment: number) {
        const begin = new FtDate(ymFrom).addMonth(increment * incrementUnit).ym();
        const end = new FtDate(begin).addMonth(incrementUnit - 1).ym();
        move(begin, end);
    }

    return (
        <div style={{display: 'flex', gap: 16, flexWrap: 'wrap'}}>
            <div>
                <div style={{display: 'flex', alignItems: 'center', gap: 4}}>
                    <YMInput value={ymFromInput} onChange={setYmFromInput}/>
                    <span>-</span>
                    <YMInput value={ymToInput} onChange={setYmToInput}/>
                    <FtButton variant="contained"
                              onClick={() => onChange(ymFromInput, ymToInput)}
                    >이동</FtButton>
                </div>
            </div>
            <div style={{display: "flex", gap: 8}}>
                <DateNav
                    todayLabel={mode === 'MONTH' ? '이번달' : '올해'}
                    onToday={() => todayAction()}
                    onPrev={() => increase(-1)}
                    onNext={() => increase(1)}
                />

                {recent && (
                    <FtButton
                        variant="outlined"
                        onClick={() => move(new FtDate().addMonth(-recent + 1).ym(), new FtDate().ym())}>최근 {recent}개월</FtButton>
                )}
            </div>
        </div>
    );
}
